import { connect } from 'react-redux';
import CreateNewVisitWhenCampaignChanges from './CreateNewVisitWhenCampaignChanges';

const mapStateToProps = state => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default connect(mapStateToProps, null)(CreateNewVisitWhenCampaignChanges);
